<template>
    <div class="image-text-preset1" :class="{ 'reverse': reverse }">
        <div class="img">
            <img :src="image" class="img-fluid" />
        </div>
        <div class="txt">
            <h2>{{ title }}</h2>
            <p v-html="content"></p>
            <div class="btn-container">
                <b-link v-if="buttonText && buttonLink" :href="buttonLink" class="btn btn-outline-primary" :target="target">
                    {{ buttonText }}
                </b-link>
            </div>
        </div>
    </div>
</template>

<script>
import { BLink } from 'bootstrap-vue';

export default {
    name: 'LandingPageImageTextBoxDefault',
    components: {
        BLink
    },
    props: {
        image: {
            type: String,
            required: true
        },
        title: {
            type: String
        },
        content: {
            type: String
        },
        buttonText: {
            type: String
        },
        buttonLink: {
            type: String
        },
        target: {
            type: String
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    
}
</script>
